"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";
import { Tabs, TabsList, TabsTrigger } from "@/shared/ui/tabs";
import { ScrollArea, ScrollBar } from "@/shared/ui/scroll-area";
import type { NavigationMenuItem } from "./navigation-sidebar";
import { useTranslations } from "next-intl";

interface NavigationTabMenuProps {
  menuItems: NavigationMenuItem[];
  defaultTab?: string;
  className?: string;
}

export function NavigationTabMenu({ menuItems, defaultTab, className }: NavigationTabMenuProps) {
  const pathname = usePathname();
  const t = useTranslations();

  // 현재 활성 탭 찾기
  const activeTab = menuItems.find((item) => item.href === pathname)?.id || defaultTab || menuItems[0]?.id;

  return (
    <div className={`w-full border-b border-gray-100 ${className || ""}`}>
      <ScrollArea className="w-full whitespace-nowrap">
        <Tabs value={activeTab} className="w-full">
          <TabsList className="inline-flex h-full w-auto justify-start p-0">
            {menuItems.map((item) => (
              <TabsTrigger
                key={item.id}
                value={item.id}
                className="body-lg-medium data-[state=active]:text-primary-600 data-[state=active]:border-primary-600 flex flex-shrink-0 items-center rounded-none border-b-2 border-transparent bg-white px-4 py-3 whitespace-nowrap data-[state=active]:bg-white data-[state=active]:font-bold"
                asChild
              >
                <Link href={item.href}>
                  <span>{t(item.label)}</span>
                </Link>
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}
